<template>
	<div>
		<v-btn
			v-if="copyImgBtn"
			id="copy-img-btn-all"
			color="red"
			:disabled="downloading"
			:loading="downloading"
			dark
			@click1="copyImage($refs[`gallery-${fotorama.activeIndex}`])"
			@click="downloadAll()"
		>
			บันทึกภาพทั้งหมด
		</v-btn>
		<v-btn
			v-if="copyImgBtn"
			id="copy-img-btn"
			color="red"
			:disabled="downloading"
			:loading="downloading"
			dark
			@click="copyImage($refs[`gallery-${fotorama.activeIndex}`])"
		>
			บันทึกภาพนี้
		</v-btn>

		<div
			id="fotorama"
			ref="fotorama"
			class="fotorama"
			data-nav="thumbs"
			data-allowfullscreen="true"
			data-loop="true"
		>
			<img
				v-for="(item, index) in items"
				:id="`gallery-${index}`"
				:key="index"
				:ref="`gallery-${index}`"
				:src="item.data.attrs.src"
				:alt="item.data.attrs.alt"
			>
		</div>
	</div>
</template>

<script>
import 'fotorama/fotorama.css'

export default {
	props: {
		image: {
			type: Number,
			default: null
		},
	},

	data() {
		return {
			items: null,
			fotorama: null,
			copyImgBtn: false,
			downloading: false,
		}
	},

	watch: {
		image (index) {
			if (index === -1 && this.fotorama) {
				this.fotorama.cancelFullScreen()
			} else if ((index || index === 0) && index > -1 && this.fotorama) {
				this.fotorama.show(index)
				this.fotorama.requestFullScreen()
				this.$emit('opened')
			}
		}
	},

	mounted() {
		this.items = this.$slots.default.filter(ele => ele.tag === 'img')

		if (process.client) {
			this.$nextTick(async () => {
				const jq = await import('jquery')
				window.jQuery = jq.default
				window.jQuery(async () => {
					await import('fotorama/fotorama.js')
					const $fotorama = window.jQuery(this.$refs.fotorama)
					// window.jQuery('.fotorama').on('fotorama:ready', (e, fotorama) => {
					$fotorama.on('fotorama:ready', (e, fotorama) => {
						this.fotorama = fotorama
					}).fotorama()
					$fotorama.on('fotorama:fullscreenenter', () => {
						this.copyImgBtn = true
						this.$emit('closed')
					})
					$fotorama.on('fotorama:fullscreenexit', () => {
						this.copyImgBtn = false
						this.$emit('closed')
					})

					// require(['fotorama/fotorama'], () => {
					// eslint-disable-next-line
					// this.fotorama = $('.fotorama').fotorama().data('fotorama')
					// })
				})
			})
		}
	},

	beforeDestroy() {
		if (process.client && this.fotorama) {
			window.jQuery(this.$refs.fotorama).off() // Clean up event listeners
			this.fotorama.destroy()
			this.fotorama = null
			delete window.jQuery
		}
	},

	methods: {
		copyImage (ref) {
			const elm = ref[0]
			if (elm.src) {
				// this.imageElementToBlob(ref, blob => {
				// 	navigator.clipboard.write([
				// 		// eslint-disable-next-line no-undef
				// 		new ClipboardItem({
				// 			'image/jpeg': blob
				// 		})
				// 	])
				// })

				// const path = elm.src.split('/')
				// console.log(path[path.length - 1])

				if (window.flutter_inappwebview && window.flutter_inappwebview?.callHandler) {
					try {
						window.flutter_inappwebview.callHandler('downloadImage', elm.src)
					} catch (e) {
						console.error('ไม่สามารถดาวน์โหลดรูปภาพนี้ได้')
					}
				} else {
					// Fetch the image as a blob and trigger download
					this.downloading = true
					fetch(elm.src, {mode: 'cors'})
						.then(response => response.blob())
						.then(blob => {
							const url = URL.createObjectURL(blob);
							const a = document.createElement('a');
							a.style.display = 'none';
							a.href = url;
							// Use the original filename or fallback
							const match = elm.src.match(/(\d+-[\da-zA-Z]+\.rl\.jpg)/g);
							a.download = match ? match[0] : 'download.jpg';
							document.body.appendChild(a);
							a.click();
							setTimeout(() => {
								document.body.removeChild(a);
								URL.revokeObjectURL(url);
							}, 100);
						})
						.catch(() => {
							alert('ไม่สามารถดาวน์โหลดรูปภาพนี้ได้');
						})
						.finally(() => {
							this.downloading = false;
						});
				}
			}
		},

		imageElementToBlob(imageElement, callback, format = 'image/jpeg', quality = 1) {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			canvas.width = imageElement.naturalWidth;
			canvas.height = imageElement.naturalHeight;
			ctx.drawImage(imageElement, 0, 0); //

			// The toBlob method is asynchronous
			canvas.toBlob(callback, format, quality);
		},

		async downloadAll () {
			if (window.flutter_inappwebview && window.flutter_inappwebview?.callHandler) {
				let allNames = this.items.map(item => item?.data?.attrs?.src || '').join(',')
				try {
					window.flutter_inappwebview.callHandler('downloadImage', allNames)
				} catch (e) {
					console.error('ไม่สามารถดาวน์โหลดรูปภาพได้')
				}
			} else {
				this.downloading = true

				let zipFileName = null
				const urls = this.items.map((item, i) => {
					const url = item.data.attrs.src || ''
					const match = url.match(/(\d+)-([\da-zA-Z]+\.rl\.jpg)/)
					if (match) {
						zipFileName = `${match[1]}.zip`
					}

					return { url, filename: match ? match[0] : `${i}.jpg` }
				})
				await this.$multipleDownloadAsZip(urls, zipFileName || 'files.zip')

				this.downloading = false
			}
		}
	}
}

</script>

<style lang="scss" scoped>
#fotorama {
	z-index: 2147483646 !important;

	&.fotorama.fotorama--fullscreen::v-deep .fotorama__fullscreen-icon {
		background-position: -64px 0px;
		top: 15px !important;
		right: 15px !important;
	}
}
#copy-img-btn-all {
	position: fixed;
	z-index: 2147483647 !important;
	top: 15px;
	left: 15px;
}
#copy-img-btn {
	position: fixed;
	z-index: 2147483647 !important;
	top: 55px;
	left: 15px;
}
</style>
